import React, { useEffect, useContext, useState } from "react";
//img
import profileImg from "../../../assets/images/png/Profile.png";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
//css
import classes from "./CostCenterTab.module.css";
//components
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import PaginantionComponent from "../../../components/common/Pagination/PaginationComponent";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import { Box, Fade, Modal, Zoom } from "@mui/material";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
// import DCheckboxInput from "../../../components/Dashboard/DashboardInputs/DCheckboxInput";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
//API
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import {
  emptyCheck,
  validateFile,
  validateNumber,
} from "../../../utils/validations";
import { MoreHoriz } from "@mui/icons-material";
import { nextPageClick, previouPageClick } from "../../../utils/pagination";
//custom hooks
import useFetchData from "../../../hooks/useFetchData";
import DFileUpload from "../../../components/Dashboard/DashboardInputs/DFileUpload";
import DefaultLabel from "../../../components/Dashboard/DefaultLabel/DefaultLabel";
//smaple xl/ csv file for download
import sampleCSV from "../../../assets/files/Sample Cost Center CSV.xlsx";
import { saveAs } from "file-saver";
import unspscCodes from "../../../data/unspsc.json";
import hsnCodes from "../../../data/hsn.json";
import { getUniqueData } from "../../../utils/getUniqueData";
import { downloadFile } from "../../../utils/downloadFile";
import DropdownBtnOutlined from "../../../components/Dashboard/DropdownButtons/DropdownBtnOutlined/DropdownBtnOutlined";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";
import set from "date-fns/fp/set/index";
import { CurrencyContext } from "../../../context/CurrencyContext";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";
import { getDepartmentCodePrefix } from "../../../utils/departmentPrefix";

const formatDateTime=(dateValue)=>{
if(!dateValue) return "-"

const date = new Date(dateValue);

if(Number.isNaN(date.getTime())) return "-";
return new Intl.DateTimeFormat("en-IN",{
  day:"2-digit",
  month:"short",
  year:"numeric",
  hour:"2-digit",
  minute:"2-digit",
  hour12:true,
  timeZone:"Asia/Kolkata",

}).format(date)
}

const CostCenterTab = () => {
  //dispatcher
  const dispatch = useDispatch();

  //get data from use selector
  const data = useSelector((state) => state.loginData.value);
  const CostDataData = useSelector((state) => state.CostData);
  const buyer_token = data?.user?.token;

  // const itemsData = '';

  //popuptext
  const [popupHeroText, setPopupHeroText] = useState("");
  const [popupMessage, setPopupMessage] = useState("");

  //search filtered data
  const [searchQuery, setSearchQuery] = useState("");

  const [sortingColumnName, setSortingColumnName] = useState("created_date");
  const [sortingOrder, setSortingOrder] = useState("desc");
  // const order = sortingOrder === null || sortingOrder === "asc" ? "desc" : "asc";
  //unique user
  const [uniqueData, setUniqueData] = useState();
  const [uniqueDataID, setUniqueDataID] = useState("");

  //credentials
  const [auth_token, setAuthToken] = useState(data?.auth_token);
  const [user_token, setUserToken] = useState(data?.user?.user_token);
  const [org_token, setOrgToken] = useState(data?.user?.token);
  const [pageNumber, setPageNumber] = useState(1);

  //pagination data
  const [paginationData, setPaginationData] = useState();

  //get org users
  const [users, setUsers] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [userError, setUserError] = useState(false);
  const [orgName, setOrgName] = useState();
  const [orgId, setOrgId] = useState();
  const [configUsers, setConfigUsers] = useState([]);

  //pagination logics
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = paginationData?.current_page_count;
  const totalItems = paginationData?.page_count;

  //btn label
  const [loadingState, setLoadingState] = useState(false);
  const [loadingStateDwnload, setLoadingStateDwnload] = useState(false);

  //button label
  const [primaryBtnLabel, setPrimaryBtnLabel] = useState();

  //toggle add/update actions
  const [itemsAction, setItemsAction] = useState({
    addItem: false,
    updateItem: false,
    addBulkItem: false,
  });

  const [UNSPSCList, setUNSPSCList] = useState(
    unspscCodes?.map((e) => e.commodity + " - " + e.commodity_name)
  );
  const [HSNList, setHSNList] = useState(
    hsnCodes?.map((e) => e.hsn_code + " - " + e.description)
  );

  // error message
  const [primaryBtnError, setPrimaryBtnError] = useState({
    error: false,
    errorMsg: "",
  });
  const [tableProps, setTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });

  const [approvers, setApprovers] = useState([]);

  const { fromCurrency, setFromCurrency } = useContext(CurrencyContext);

  const regexForAlphabets = /[^a-zA-Z\s]/g;
  const regexForAlphaNumeric = /[^a-zA-Z0-9\s]+/g;
  const specialAlphaNumericRegex = /^[a-zA-Z0-9\s\W]+$/;
  const regexForNumber = /[^\d\s]/g;
  const COST_CENTER_CODE_MAX_LENGTH = 20;
  const DEPARTMENT_NAME_MAX_LENGTH = 30;
  const sanitizeCostCenterCode = (value) =>
    String(value ?? "")
      .replace(/[^a-zA-Z0-9\-_/\s]/g, "")
      .replace(/\s+/g, " ")
      .slice(0, COST_CENTER_CODE_MAX_LENGTH);
  const sanitizeDepartmentName = (value) =>
    String(value ?? "")
      .replace(/[^a-zA-Z\s]/g, "")
      .replace(/\s+/g, " ")
      .slice(0, DEPARTMENT_NAME_MAX_LENGTH);

  const GetUserList = async () => {
    await axios({
      url: `${API_ENDPOINT.user_list}`,
      method: "POST",
      data: {
        user_token: user_token,
      },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setUsers(res.data.user_list);
        setOrgName(res.data.org_name);
        setOrgId(res.data.org_id);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const GetConfigList = async (
    sortBy = sortingColumnName,
    order = sortingOrder
  ) => {
    const formData = new FormData();
    formData.append("org_id", orgId);
    formData.append("search", searchQuery);
    formData.append("page", pageNumber);
    formData.append("buyer_token", buyer_token);

    // Apply sorting parameters
    if (sortBy) {
      const normalizedOrder = order === "asc" || order === "desc" ? order : "desc";
      formData.append("sort_by", sortBy);
      formData.append("order", normalizedOrder);
    }

    try {
      const response = await axios.post(
        `${API_ENDPOINT.cost_center_list}`,
        formData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );

      const { total_count, page_count, current_page_count } = response.data;
      const results = Array.isArray(response.data.results)
        ? response.data.results
        : [];
      const sortedResults =
        sortBy === "created_date"
          ? [...results].sort(
              (a, b) =>
                new Date(b?.created_date || 0) - new Date(a?.created_date || 0)
            )
          : results;

     const formattedResults = sortedResults.map((item) => ({
  ...item,
  created_date_display: formatDateTime(item?.created_date),
}));

setConfigUsers(formattedResults);
      setPaginationData({
        currentPage: pageNumber || 1,
        totalItems: total_count,
        current_page_count,
        page_count,
      });
    } catch (error) {
      console.error("Error fetching cost centers:", error);
    }
  };

  const itemsData = configUsers;

  const handleAddApprover = () => {
    let updatedApprovers = [...approvers];
    if (updatedApprovers.length > 0) {
      updatedApprovers[updatedApprovers.length - 1].showPlus = false;
    }
    const newApprover = { id: approvers.length + 1, value: "", showPlus: true };
    updatedApprovers.push(newApprover);
    setApprovers(updatedApprovers);
  };

  const handleRemoveApprover = (id = null) => {
    let updatedApprovers;

    if (id === null) {
      updatedApprovers = [];
    } else {
      updatedApprovers = approvers.filter((approver) => approver.id !== id);
    }

    if (updatedApprovers.length > 0) {
      updatedApprovers[updatedApprovers.length - 1].showPlus = true;
    }

    setApprovers(updatedApprovers);
  };

  // useEffect(() => {
  //   if (orgId) {
  //     GetConfigList();
  //   }
  // }, [orgId, searchQuery, pageNumber, sortingColumnName, sortingOrder]);

  const getFilteredOptions = (currentApprover, index) => {
    const selectedApproversList = [
      selectedApprovers.value,
      ...(Array.isArray(approvers)
        ? approvers.map((approver) => approver.value)
        : []),
    ].filter(Boolean);

    return userOptions.values.visibleOption.filter(
      (option) =>
        !selectedApproversList.includes(option) || option === currentApprover
    );
  };

  const userOptions = {
    values: {
      tokens: users?.map((user) => user.id) || [],
      visibleOption: users?.map((user) => user.full_text) || [],
    },
  };

  const initializeSelectedApprovers = (existingEmails) => {
    const defaultApproverEmail = existingEmails[0] || "";
    const defaultApproverId =
      userOptions.values.tokens[
        userOptions.values.visibleOption.indexOf(defaultApproverEmail)
      ] || "";
    setSelectedApprovers({
      value: defaultApproverEmail,
      id: defaultApproverId,
      isValid: defaultApproverEmail !== "",
    });

    const dynamicApprovers = existingEmails.slice(1).map((full_text, index) => {
      const emailId =
        userOptions.values.tokens[
          userOptions.values.visibleOption.indexOf(full_text)
        ];
      return {
        id: emailId,
        value: full_text,
        showPlus: index === existingEmails.length - 2,
      };
    });
    setApprovers(dynamicApprovers);
  };

  let delay = 300;

  //get users data for table view
  useEffect(() => {
    let timeoutId = null;

    timeoutId = setTimeout(() => {
      if (pageNumber) {
      }
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [pageNumber, searchQuery, sortingColumnName, sortingOrder]);

  useEffect(() => {
    setPrimaryBtnLabel(
      itemsAction.addItem
        ? "Add"
        : itemsAction.updateItem
        ? "Update"
        : itemsAction.addBulkItem
        ? "Add"
        : ""
    );
  }, [itemsAction]);

  useEffect(() => {
    GetUserList();
  }, []);

  useEffect(() => {
    if (orgId) {
      GetConfigList();
    }
  }, [orgId, searchQuery, pageNumber, sortingColumnName, sortingOrder]);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, buyerAdmin_master_search } = JSON.parse(chatActionRaw);

    if (action === "search_cost_center") {
      if (!itemsData || itemsData.length === 0) return;

      console.log(buyerAdmin_master_search?.searchText);
      setSearchQuery(buyerAdmin_master_search?.searchText || "");
      setPageNumber(1);

      sessionStorage.removeItem("CHAT_ACTION");
    }

    if (action === "add_cost_center") {
      handleOpenAddItem();
    }
  }, [itemsData]);

  const updateInputs = (data) => {
    setStageName((prev) => ({
      ...prev,
      value: data?.costcenter_code,
      isValid: true,
    }));

    const existingDepartment = normalizeDepartmentName(data?.department);
    setSelectedDepartmentOption(existingDepartment || null);
    setOtherDepartmentName({
      value: "",
      isValid: true,
      errorMsg: "",
    });

    setIsCostCenterCodeEdited(true);

    if (data?.users?.length > 0) {
      setSelectedApprovers((prev) => ({
        ...prev,
        value: data.users[0],
        id: userOptions.values.tokens[
          userOptions.values.visibleOption.indexOf(data.users[0])
        ],
        isValid: true,
      }));

      const remainingApprovers = data.users.slice(1).map((user, index) => ({
        value: user,
        id: userOptions.values.tokens[
          userOptions.values.visibleOption.indexOf(user)
        ],
        isValid: true,
        showPlus: index === data.users.length - 2,
      }));

      setApprovers(remainingApprovers);
    } else {
      setSelectedApprovers((prev) => ({
        ...prev,
        value: [],
        id: [],
        isValid: false,
      }));
    }
    setFromCurrency((prev) => ({
      ...prev,
      currency: data?.currency_type,
      countryName: data?.country_name && data?.country_name,
    }));
  };

 

  //demo data for the datatable
  const headings = [
    {
      label: "Cost Center Code",
      field: "costcenter_code",
      col_width: "250px",
      noWrap: true,
    },
    { label: "Department", field: "department" },
    { label: "Created Date", field: "created_date_display" },
  ];

  // modal states
  const [open, setOpen] = useState(false);

  const handleOpenAddItem = () => {
    setOpen(true);
    resetForm();
    ensureDepartmentsLoaded();
    setItemsAction({
      addItem: true,
      updateItem: false,
    });
    // addCodesList(hsnCodes, setHSNList);
  };

  const handleOpenAddBulkItem = () => {
    setOpen(true);
    resetForm();
    setItemsAction({
      addItem: false,
      updateItem: false,
      addBulkItem: true,
    });
  };
  const handleOpenEditItem = (unique_id) => {
    setOpen(true);
    ensureDepartmentsLoaded();
    let rowData = getUniqueData(itemsData, "id", unique_id);
    rowData = {
      ...rowData,
      users: rowData.users
        ? rowData.users.map((user) => user.full_text.trim())
        : [],
    };
    const existingApproversEmails = rowData.users;
    initializeSelectedApprovers(existingApproversEmails);

    updateInputs(rowData);
    setUniqueDataID(unique_id);
    setItemsAction({
      addItem: false,
      updateItem: true,
    });
  };

  const handleClose = () => {
    setOpen(false);
    setPrimaryBtnError({
      error: false,
      errorMsg: "",
    });
    setApprovers([]);
    setSelectedApprovers([]);
  };

  // S - success popup
  const [openS, setOpenS] = useState(false);
  const handleOpenS = () => {
    setOpenS(true);
  };
  const handleCloseS = () => {
    setOpenS(false);
  };

  // VU - View User popup
  const [openViewItemPopup, setOpenViewItemPopup] = useState(false);
  const handleOpenViewItemPopup = (unique_id) => {
    let rowData = getUniqueData(itemsData, "id", unique_id);
    setUniqueData(rowData);
    setOpenViewItemPopup(true);
  };
  const handleCloseViewItemPopup = () => {
    setOpenViewItemPopup(false);
  };

  // viewItemsActionButtons
  const viewItemsActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewItemPopup}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={"OK"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleCloseViewItemPopup}
    />,
  ];
  const viewUserChildren = [
    <InfoLabel
      size={"80%"}
      label={"Cost center code"}
      value={uniqueData?.costcenter_code}
    />,
    <InfoLabel size={"80%"} label={"Department"} value={uniqueData?.department || "-"} />,
  ];

  const viewUserHeading = (
    <HeaderTitle
      titleText={
        uniqueData?.costcenter_code || <MoreHoriz sx={{ fontSize: "30px" }} />
      }
      customclass={classes.VUpopupHeading}
    />
  );

  //common states for CRUD
  const [itemName, setItemName] = useState({
    value: "",
    isValid: true,
  });
  const [itemCode, setItemCode] = useState({
    value: "",
    isValid: true,
  });
  const [ItemCategory, setItemCategory] = useState({
    value: "",
    isValid: true,
  });
  const [csvFile, setCsvFile] = useState({
    value: "",
    isValid: true,
  });
  const [user, setUser] = useState({
    value: "",
    isValid: true,
  });
  const [departmentList, setDepartmentList] = useState([]);
  const DEPARTMENT_OTHERS_OPTION = "Others";
  const [selectedDepartmentOption, setSelectedDepartmentOption] = useState(null);
  const [otherDepartmentName, setOtherDepartmentName] = useState({
    value: "",
    isValid: true,
    errorMsg: "",
  });
  const [isCostCenterCodeEdited, setIsCostCenterCodeEdited] = useState(false);

  const normalizeDepartmentName = (name) =>
    String(name ?? "")
      .trim()
      .replace(/\s+/g, " ");

  const isDuplicateDepartment = (name) => {
    const cleaned = normalizeDepartmentName(name).toLowerCase();
    if (!cleaned) return false;

    return (departmentList || [])
      .filter((d) => d?.status === 1 || d?.status === undefined)
      .some(
        (d) => normalizeDepartmentName(d?.name).toLowerCase() === cleaned
      );
  };

  const isOtherSelected = selectedDepartmentOption === DEPARTMENT_OTHERS_OPTION;
  const effectiveDepartmentName = isOtherSelected
    ? normalizeDepartmentName(otherDepartmentName.value)
    : selectedDepartmentOption;

  // const [startPrice, setStartPrice] = useState({
  //   value: "",
  //   isValid: true,
  // });
  // const [endPrice, SetEndPrice] = useState({
  //   value: "",
  //   isValid: true,
  // });
  const [stageName, setStageName] = useState({
    value: "",
    isValid: true,
  });
  const [currencyType, setCurrencyType] = useState({
    value: "",
    isValid: true,
  });
  const [selectedApprovers, setSelectedApprovers] = useState({
    value: [],
    id: [],
    isValid: true,
  });

  // const [vendorId, setVendorID] = useState([]);
  const [existingVendorList, setExistingVendorList] = useState([]);

  const deptPrefix = effectiveDepartmentName
    ? getDepartmentCodePrefix(effectiveDepartmentName)
    : "";

  const fetchDepartments = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_Department}`,
        { user_token: org_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );
      setDepartmentList(response.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const ensureDepartmentsLoaded = () => {
    if (departmentList?.length) return;
    fetchDepartments();
  };

  const resetForm = () => {
    setItemCode({
      value: "",
      isValid: true,
    });
    setItemCategory({
      value: "",
      isValid: true,
    });
    setItemName({
      value: "",
      isValid: true,
    });
    setCsvFile({
      value: "",
      isValid: true,
    });
    setStageName({
      value: "",
      isValid: true,
    });
    setSelectedDepartmentOption(null);
    setOtherDepartmentName({
      value: "",
      isValid: true,
      errorMsg: "",
    });
    setIsCostCenterCodeEdited(false);
    setSelectedApprovers({
      value: "",
      id: "",
      isValid: true,
    });
  };

  useEffect(() => {
    if (!itemsAction.addItem) return;
    if (!deptPrefix) {
      if (!isCostCenterCodeEdited) {
        setStageName((prev) => ({
          ...prev,
          value: "",
        }));
      }
      return;
    }

    if (isCostCenterCodeEdited) return;

    const combined = `${deptPrefix}-`;
    setStageName((prev) => ({
      ...prev,
      value: combined,
      isValid: prev.isValid ? prev.isValid : emptyCheck(combined),
    }));
  }, [itemsAction.addItem, deptPrefix, isCostCenterCodeEdited]);

  useEffect(() => {
    if (!itemsAction.updateItem) return;
    if (!departmentList?.length) return;
    if (!selectedDepartmentOption) return;
    if (selectedDepartmentOption === DEPARTMENT_OTHERS_OPTION) return;

    const isInList = (departmentList || [])
      .filter((d) => d?.status === 1 || d?.status === undefined)
      .some(
        (d) =>
          normalizeDepartmentName(d?.name).toLowerCase() ===
          normalizeDepartmentName(selectedDepartmentOption).toLowerCase()
      );

    if (!isInList) {
      setSelectedDepartmentOption(DEPARTMENT_OTHERS_OPTION);
      setOtherDepartmentName({
        value: selectedDepartmentOption,
        isValid: true,
        errorMsg: "",
      });
    }
  }, [
    itemsAction.updateItem,
    departmentList,
    selectedDepartmentOption,
    DEPARTMENT_OTHERS_OPTION,
  ]);

  const validateForm = (query) => {
    const otherDuplicate =
      isOtherSelected && !!otherDepartmentName.value
        ? isDuplicateDepartment(otherDepartmentName.value)
        : false;
    const isOtherValid = isOtherSelected
      ? emptyCheck(otherDepartmentName.value) && !otherDuplicate
      : true;

    setOtherDepartmentName((prev) => ({
      ...prev,
      isValid: isOtherValid,
      errorMsg: !isOtherSelected
        ? ""
        : !emptyCheck(otherDepartmentName.value)
        ? "Department name is required"
        : otherDuplicate
        ? "Department already exists"
        : "",
    }));

    const isStageName = itemsAction.addItem
      ? emptyCheck(effectiveDepartmentName) &&
        emptyCheck(stageName.value) &&
        isOtherValid
      : itemsAction.updateItem
      ? emptyCheck(effectiveDepartmentName)
        ? emptyCheck(stageName.value) && isOtherValid
        : emptyCheck(stageName.value)
      : emptyCheck(stageName.value);

    const isCsvFile = validateFile(
      csvFile.value,
      false,
      ["csv", "xlsx"],
      5
    ).isValid;
    setStageName((prev) => ({
      ...prev,
      isValid: isStageName,
    }));

    if (query === "bulkData") {
      setCsvFile((prev) => ({
        ...prev,
        isValid: isCsvFile,
      }));

      return isCsvFile;
    } else {
      return isStageName;
    }
  };

  // ADD Item function
  const addItem = async () => {
    const defaultApproverID = selectedApprovers.id;

    const dynamicApproversIDs =
      approvers.length > 0
        ? approvers.map((approver) => approver.id).filter(Boolean)
        : "";
    const approversIDs = [defaultApproverID, ...dynamicApproversIDs];

    const formData = new FormData();
    formData.append("id", "");
    formData.append("org_id", orgId);
    formData.append("costcenter_code", stageName.value);
    formData.append("department", effectiveDepartmentName || "");
    formData.append("users", approversIDs);

    await axios({
      url: `${API_ENDPOINT.add_cost_center}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        // GetAllData();
        setPopupHeroText("Cost Center Added!");
        setPopupMessage(res?.data?.response);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
        setSelectedApprovers("");
        setApprovers("");
        GetConfigList();
      })
      .catch((err) => {
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
        setLoadingState(false);
      });
  };

  // ADD Bulk Items function
  const addBulkItems = async () => {
    const formData = new FormData();

    formData.append("org_token", org_token);
    formData.append("csv_file", csvFile.value);

    await axios({
      url: `${API_ENDPOINT.add_bulkcode}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        //GetAllData();
        GetConfigList();
        setPopupHeroText("Items Added!");
        setPopupMessage(res?.data?.response);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
      })
      .catch((err) => {
        setPrimaryBtnError({
          error: true,
          errorMsg:
            (typeof err?.response?.data?.response !== "object" &&
              err?.response?.data?.response) ||
            "Something went wrong! please check the file values & try again.",
        });
        setLoadingState(false);
      });
  };

  // Update item submit click
  const updateItem = async () => {
    console.log("kkaaaaaaa");
    // console.log('approvers', approvers)
    // console.log('selectedApprovers', selectedApprovers)
    const defaultApproverID = selectedApprovers.id;
    const dynamicApproversIDs = approvers
      .map((approver) => approver.id)
      .filter(Boolean);
    const approversIDs = [defaultApproverID, ...dynamicApproversIDs];
    const formData = new FormData();
    formData.append("id", uniqueDataID);
    formData.append("org_id", orgId);
    formData.append("costcenter_code", stageName.value);
    if (selectedDepartmentOption) {
      formData.append("department", effectiveDepartmentName || "");
    }
    formData.append("users", approversIDs);

    await axios({
      url: `${API_ENDPOINT.add_cost_center}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        //GetAllData();
        GetConfigList();
        setPopupHeroText("Cost Center Updated!");
        setPopupMessage(res?.data?.response);
        handleClose();
        handleOpenS();
        resetForm();
        setLoadingState(false);
        GetConfigList();
        setApprovers("");
      })
      .catch((err) => {
        console.log(err);
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
        setLoadingState(false);
      });
  };

  //submit click ADD/UPDATE item
  const handleSubmit = () => {
    const validation = itemsAction.addBulkItem
      ? validateForm("bulkData")
      : validateForm();
    console.log("validationvalidation", validation);
    if (validation) {
      if (itemsAction.addItem) {
        setLoadingState(true);
        addItem();
      } else if (itemsAction.updateItem) {
        setLoadingState(true);
        updateItem();
      } else if (itemsAction.addBulkItem) {
        setLoadingState(true);
        addBulkItems();
      }
    } else {
      setItemName((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setItemCode((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setItemCategory((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setCsvFile((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setStageName((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setUser((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
    }
  };

  //category select options
  const selectCategory = ["Select", "IT", "Stationary"];

  // INPUTS
  const InputsHeading = (
    <HeaderTitle
      titleText={
        itemsAction.addItem
          ? "Add Cost Center "
          : itemsAction.updateItem
          ? "Update Cost Center"
          : itemsAction.addBulkItem
          ? "Add Bulk Cost center Code"
          : ""
      }
      customclass={classes.popupHeading}
    />
  );

  const ItemInputs = [
    <>
      {itemsAction.addItem || itemsAction.updateItem ? (
        <>
          <DSelectInput
            label="Department"
            options={(departmentList || [])
              .filter((d) => d?.status === 1 || d?.status === undefined)
              .map((d) => d?.name)
              .filter(Boolean)
              .filter((name) => name !== DEPARTMENT_OTHERS_OPTION)
              .concat(DEPARTMENT_OTHERS_OPTION)}
            value={selectedDepartmentOption}
            onChange={(newValue) => {
              const nextValue = newValue || null;
              setSelectedDepartmentOption(nextValue);
              setIsCostCenterCodeEdited(false);

              if (nextValue === DEPARTMENT_OTHERS_OPTION) {
                setOtherDepartmentName({
                  value: "",
                  isValid: true,
                  errorMsg: "",
                });
              } else {
                setOtherDepartmentName({
                  value: "",
                  isValid: true,
                  errorMsg: "",
                });
              }

              if (!nextValue) {
                setStageName((prev) => ({
                  ...prev,
                  value: "",
                }));
                return;
              }

            }}
            error={itemsAction.addItem && !stageName.isValid && !selectedDepartmentOption}
            errorMsg="Department is required"
            customClass={classes.popupFields}
            size={"45%"}
          />

          {isOtherSelected && (
            <DTextInput
              label="Department Name"
              type="text"
              maxLength={DEPARTMENT_NAME_MAX_LENGTH}
              value={otherDepartmentName.value}
              onChange={(e) => {
                const val = sanitizeDepartmentName(e.target.value);
                const duplicate = !!val ? isDuplicateDepartment(val) : false;
                const isValid = emptyCheck(val) && !duplicate;
                setOtherDepartmentName({
                  value: val,
                  isValid,
                  errorMsg: !emptyCheck(val)
                    ? "Department name is required"
                    : duplicate
                    ? "Department already exists"
                    : "",
                });
                if (!isCostCenterCodeEdited) {
                  const nextPrefix = getDepartmentCodePrefix(val);
                  setStageName((prev) => ({
                    ...prev,
                    value: nextPrefix ? `${nextPrefix}-` : "",
                    isValid: true,
                  }));
                }
              }}
              error={isOtherSelected && !otherDepartmentName.isValid}
              customClassName={classes.popupFields}
              errorMsg={otherDepartmentName.errorMsg || "Department name is required"}
              size={"45%"}
            />
          )}

          <div style={{ display: "flex", gap: "1.2rem", width: "45%" }}>
            {emptyCheck(effectiveDepartmentName) ? (
              <DTextInput
                label="Cost Center Code"
                type="text"
                maxLength={COST_CENTER_CODE_MAX_LENGTH}
                value={stageName.value}
                disabled={isOtherSelected && !otherDepartmentName.isValid}
                onChange={(e) => {
                  const val = sanitizeCostCenterCode(e.target.value);
                  setIsCostCenterCodeEdited(true);
                  setStageName({
                    value: val,
                    isValid: emptyCheck(val),
                  });
                }}
                error={
                  !stageName.isValid &&
                  (itemsAction.addItem || itemsAction.updateItem) &&
                  !emptyCheck(stageName.value)
                }
                customClassName={classes.popupFields}
                errorMsg={"Cost Center Code is required"}
                size={"100%"}
              />
            ) : (
              <DTextInput
                label="Cost Center Code"
                type="text"
                maxLength={COST_CENTER_CODE_MAX_LENGTH}
                value={stageName.value}
                onChange={(e) => {
                  let val = sanitizeCostCenterCode(e.target.value);
                  setIsCostCenterCodeEdited(true);
                  setStageName({
                    value: val,
                    isValid: emptyCheck(val),
                  });
                }}
                error={!stageName.isValid}
                customClassName={classes.popupFields}
                errorMsg={"Cost Center Code is required"}
                size={"100%"}
              />
            )}
          </div>
        </>
      ) : (
        <DTextInput
          label="Cost Center Code"
          type="text"
          maxLength={COST_CENTER_CODE_MAX_LENGTH}
          value={stageName.value}
          onChange={(e) => {
            let val = sanitizeCostCenterCode(e.target.value);
            setIsCostCenterCodeEdited(true);
            setStageName({
              value: val,
              isValid: emptyCheck(val),
            });
          }}
          error={!stageName.isValid}
          customClassName={classes.popupFields}
          errorMsg={"Cost Center Code is required"}
          size={"45%"}
        />
      )}
    </>,
    //   <DButton
    //     customClass={classes.approveFieldAdd}
    //     label={approvers.length > 0 ? 'Remove' : 'Add'}
    //     btnWidth={"13rem"}
    //     btnHeight={"4rem"}
    //     loadingState={loadingState}
    //     error={primaryBtnError.error}
    //     errorMsg={primaryBtnError.errorMsg}
    //     onClick={approvers.length > 0 ? () => handleRemoveApprover(null) : handleAddApprover}
    //   />,
    <>{/* {renderApproverFields()} */}</>,
  ];

  const BulkItemInputs = [
    <div className={classes.input_container}>
      <DefaultLabel label={"Upload CSV file"} />
      <DFileUpload
        fileTypes={".xlsx,.csv"}
        customFileTypeText={"(Supported format CSV)"}
        onFileUpload={(file) => {
          let isFileValid = validateFile(
            file,
            false,
            ["csv", "xlsx"],
            5
          ).isValid;
          setCsvFile({
            value: file,
            isValid: isFileValid,
          });
        }}
        error={!csvFile.isValid}
        errorMsg={
          validateFile(csvFile.value, false, ["csv", "xlsx"], 5, "CSV file")
            .errorMessage
        }
        size={"100%"}
      />
      <p
        className={classes.linkBtn}
        onClick={() => {
          saveAs(sampleCSV, "Sample CSV");
        }}
      >
        Sample CSV
      </p>
    </div>,
  ];

  const itemsActionsButton = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleClose}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={primaryBtnLabel}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      loadingState={loadingState}
      error={primaryBtnError.error}
      errorMsg={primaryBtnError.errorMsg}
      onClick={handleSubmit}
    />,
  ];

  //deletion popups and functions
  const [hardDeleteRow, setHardDeleteRow] = useState(null);
  const deleteItem = async (deletionType) => {
    let isHardDelete = deletionType && deletionType === "hard delete";
    setLoadingState(true);

    setPopupMessage("");

    if (isHardDelete) {
      try {
        const res = await axios({
          method: "POST",
          url: `${API_ENDPOINT.delete_cost_center}`,
          data: {
            id: uniqueDataID,
            org_id: orgId,
          },
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        });

        GetConfigList();
        handleCloseDltConfirmation();
        setPopupHeroText(`Cost Center Deleted Successfully!`);
        setPopupMessage(
          res?.data?.response ||
            res?.data?.message ||
            "Cost Center deleted successfully."
        );
        setLoadingState(false);
      } catch (err) {
        // Fallback to legacy delete flow (status=3) until backend supports delete_cost_center
        const formData = new FormData();
        formData.append("id", uniqueDataID);
        formData.append("status", "3");
        formData.append("org_id", orgId);
        if (hardDeleteRow?.costcenter_code) {
          formData.append("costcenter_code", hardDeleteRow.costcenter_code);
        }
        if (Array.isArray(hardDeleteRow?.users) && hardDeleteRow.users.length) {
          const userIds = hardDeleteRow.users
            .map((u) => u?.id || u?.user_token || u?.token)
            .filter(Boolean);
          if (userIds.length) formData.append("users", userIds);
        }

        await axios({
          method: "POST",
          url: `${API_ENDPOINT.add_cost_center}`,
          data: formData,
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        })
          .then((res) => {
            GetConfigList();
            handleCloseDltConfirmation();
            setPopupHeroText(`Cost Center Deleted Successfully!`);
            setPopupMessage(res?.data?.response);
            setLoadingState(false);
            GetConfigList();
          })
          .catch((fallbackErr) => {
            setPopupHeroText("OOPS! Something went wrong");
            setPopupMessage(
              fallbackErr?.response?.data?.response ||
                err?.response?.data?.response
            );
            console.log(fallbackErr);
            setLoadingState(false);
          });
      }
    } else {
      await axios({
        method: "POST",
        url: `${API_ENDPOINT.delete_item}`,
        data: {
          token: uniqueDataID,
          status: itemStatus,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then((res) => {
          //GetAllData();
          GetConfigList();
          handleCloseDltConfirmation();
          setPopupHeroText(
            `Item ${itemStatus ? "Activated!" : "Deactivated!"}`
          );
          setPopupMessage(res?.data?.response);
          setLoadingState(false);
        })
        .catch((err) => {
          setPopupHeroText("Something went wrong!");
          setPopupMessage(err?.response?.data?.response);
          console.log(err);
          setLoadingState(false);
        });
    }
  };

  //delete data
  const [openDlt, setOpenDlt] = useState(false);
  const handleOpenDlt = () => setOpenDlt(true);
  const handleCloseDlt = () => {
    setOpenDlt(false);
  };
  const [openDltConfirmation, setOpenDltConfirmation] = useState(false);
  const [itemStatus, setItemStatus] = useState();

  const [itemHardDelete, setItemHardDelete] = useState(false);

  const handleOpenDltConfirmation = (deletion_id, rowData, deletionType) => {
    let isHardDelete = deletionType && deletionType === "hard delete";
    setItemHardDelete(isHardDelete);
    let popupMsg = rowData.status
      ? "Are you sure want to deactivate"
      : "Are you sure want to activate";
    let status = !rowData.status;
    let uniqueData = getUniqueData(itemsData, "id", deletion_id);
    console.log("kkkkkkk", uniqueData, popupMsg);
    if (isHardDelete) setHardDeleteRow(uniqueData || null);
    setPopupHeroText(
      `${isHardDelete ? "Are you sure want to delete" : popupMsg} "${
        uniqueData?.costcenter_code
      }"?`
    );
    setOpenDltConfirmation(true);
    setUniqueDataID(deletion_id);
    setItemStatus(status);
  };
  const handleCloseDltConfirmation = () => {
    setOpenDltConfirmation(false);
    setItemHardDelete(false);
    setHardDeleteRow(null);
  };
  const handleDeleteUser = () => {
    handleOpenDlt();
    itemHardDelete ? deleteItem("hard delete") : deleteItem();
    handleCloseDltConfirmation();
  };

  return (
    <div className={classes.users_tab_wrapper}>
      <div className={classes.users_topHeader}>
        <div className={`${classes.lhs} ${classes.flex}`}>
          <HeaderTitle titleText="Cost Center" customclass={classes.dashHead} />
        </div>

        {/* <div className={`${classes.notificationBar}`}>
          <DateBar />
          <NotificationBell />
          <ProfileCard
            imageSrc={profileImg}
            profilePath={"/Organization_dashboard/My_profile"}
          />
        </div> */}
      </div>

      <div className={classes.search_add_wrapper}>
        <SearchBar
          value={searchQuery}
          onChange={(query) => {
            setSearchQuery(query);
            setPageNumber(1);
          }}
          placeholder="Search by CC Code, Department"
        />

        <div
          className={classes.flex}
          style={{
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          {/* <DropdownBtnOutlined
            label="DOWNLOAD AS"
            btnHeight="4rem"
            btnWidth="18rem"
            loadingState={loadingStateDwnload}
            disabled={itemsData?.length === 0}
            onClick={(fileFormat) => {
              downloadFile({
                key: "org_token",
                value: org_token,
                fileNameProp: "Items Data",
                outputFormat: fileFormat,
                API_ENDPOINT: API_ENDPOINT.csv_org_item_view,
                authToken: auth_token,
                setLoadingState: setLoadingStateDwnload,
              });
            }}
            options={["CSV", "PDF"]}
          /> */}

          <DButtonOutlined
            iconWidth="1rem"
            iconHeight="1rem"
            label="UPLOAD"
            btnHeight="4rem"
            onClick={handleOpenAddBulkItem}
          />

          <DButton
            labelImg={plusIcon}
            iconWidth="1rem"
            iconHeight="1rem"
            label="Add Cost Center"
            btnHeight="4rem"
            onClick={handleOpenAddItem}
          />
        </div>
      </div>

      <div className={`${classes.d_dataTable}`}>
        <DataTable
          headings={headings}
          tableData={itemsData}
          actions={true}
          tableSize={itemsData?.length === 0 ? "100%" : "100%"}
          viewBtn={true}
          deleteBtn={true}
          editBtn={true}
          sorting={true}
          viewClick={handleOpenViewItemPopup}
          editClick={handleOpenEditItem}
          toggleOnChange={handleOpenDltConfirmation}
          deleteClick={(id, row) => {
            handleOpenDltConfirmation(id, row, "hard delete");
          }}
          errorMessage={tableProps.errorMessage}
          isLoading={tableProps.isLoading}
          itemsTable={true}
          setSortingColumnName={setSortingColumnName}
          sortingColumnName={sortingColumnName}
          setSortingOrder={setSortingOrder}
          sortingOrder={sortingOrder}
          stickyFirstColumn={true}
          viewTooltip="View"
          editTooltip="Edit"
          deleteTooltip="Delete"
        />

        <PaginantionComponent
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          currentPage={currentPage || 0}
          itemsPerPage={itemsPerPage || 0}
          totalItems={totalItems || 0}
          localStorageKey={"rfq_organ_page_number"}
          previouPageClick={() => {
            previouPageClick(pageNumber, setPageNumber);
          }}
          nextPageClick={() => {
            nextPageClick(pageNumber, setPageNumber, paginationData);
          }}
          disablePrevious={parseInt(pageNumber) === 1 || pageNumber === ""}
          disableNext={
            parseInt(pageNumber) === paginationData?.page_count ||
            !paginationData ||
            pageNumber === ""
          }
        />
      </div>

      {/* modal popups */}

      {/* add/update item modal */}
      <Modal
        open={open}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
        }}
      >
        <Fade in={open}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            <PopupFrame
              inputChildren={
                itemsAction.addItem
                  ? ItemInputs
                  : itemsAction.updateItem
                  ? ItemInputs
                  : itemsAction.addBulkItem
                  ? BulkItemInputs
                  : ItemInputs
              }
              poupHeading={InputsHeading}
              actionButtons={itemsActionsButton}
              closePopup={handleClose}
              customClass={
                itemsAction.updateItem ? classes.updatePopup : classes.addPopup
              }
              // styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      {/* view user modal */}
      <Modal
        open={openViewItemPopup}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={openViewItemPopup}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            <PopupFrame
              inputChildren={viewUserChildren}
              poupHeading={viewUserHeading}
              actionButtons={viewItemsActionButtons}
              closePopup={handleCloseViewItemPopup}
              width={"auto"}
              customClass={classes.addPopup}
              styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      {/* success modal */}
      <Modal open={openS}>
        <Fade in={openS}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseS}
            />
          </Box>
        </Fade>
      </Modal>

      {/* delete error modal two states - confirmation and deletion */}

      {/* confirmation */}
      <Modal open={openDltConfirmation}>
        <Fade in={openDltConfirmation}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popBtn={true}
              btnText={"Yes"}
              secondaryBtn={true}
              btnTextSecondary={"No"}
              btnClick={handleDeleteUser}
              customHeroTextClass={classes.popupTxtSm}
              btnClickSecondary={handleCloseDltConfirmation}
            />
          </Box>
        </Fade>
      </Modal>

      {/* deletion */}
      <Modal open={openDlt}>
        <Fade in={openDlt}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              btnText={"Okay"}
              loadingPrimaryBtn={loadingState}
              btnClick={handleCloseDlt}
              customHeroTextClass={classes.popupTxtSm}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default CostCenterTab;
